import React from "react";

import {
  Content,
  Grid,
  GridItem,
  PageSection,
  Stack,
  StackItem
} from "@patternfly/react-core";

import {
  ProjectDocuments,
  ProjectInfoCard,
  ProjectPageHeader
} from "apps/school-site/features/projects";

import {
  erasmusDocuments,
  erasmusProject
} from "./data/erasmusData";

const ErasmusPage = () => {
  return (
    <PageSection isWidthLimited>
      <Stack hasGutter>
        <StackItem>
          <ProjectPageHeader
            title="Erasmus+"
            description="Praktyki zawodowe dla uczniów CKZiU w Wyrzysku."
          />
        </StackItem>

        <StackItem>
          <Grid>
            <GridItem
              span={12}
              md={8}
              mdOffset={2}
            >
              <ProjectInfoCard
                title={erasmusProject.title}
                description={erasmusProject.description}
                image={erasmusProject.image}
                imagePosition="right"
                >
                <Content>
                    <p>
                    <strong>
                        {erasmusProject.location}
                    </strong>
                    <br />
                    {erasmusProject.date}
                    </p>

                    <p>
                    <strong>
                        {erasmusProject.deadline}
                    </strong>
                    </p>
                </Content>
                </ProjectInfoCard>
            </GridItem>
          </Grid>
        </StackItem>

        <StackItem>
          <Grid>
            <GridItem
              span={12}
              md={8}
              mdOffset={2}
            >
              <ProjectDocuments
                title="Dokumenty rekrutacyjne"
                documents={erasmusDocuments}
              />
            </GridItem>
          </Grid>
        </StackItem>
      </Stack>
    </PageSection>
  );
};

export default ErasmusPage;